import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import { Section, SectionTitle } from 'react-scale/components';
import Image from 'next/image';

const Credos = ({ valuesTitle, valuesSlider }) => (
  <Section bg="bg-neutral-900" id="credos">
    <SectionTitle
      overtitle={valuesTitle.overtitle}
      title={valuesTitle.title}
      subtitle={valuesTitle.subtitle}
      link={valuesTitle.link}
    />
    <div className="grid md:gap-12 md:grid-cols-2 gap-y-2">
      {valuesSlider.map(slide => (
        <div className="flex content-center sm:block" key={slide.title}>
          <div className="w-8 mb-4 mr-4 sm:mr-auto sm:w-auto">
            <Image
              src={slide.icon}
              alt={slide.title}
              width={56}
              height={56}
              quality={100}
              loading="eager"
            />
          </div>
          <ReactMarkdown
            className="text-xl font-medium text-white md:text-xl md:mb-3"
            rehypePlugins={[rehypeRaw]}
          >
            {slide.title}
          </ReactMarkdown>
          <p className="hidden text-base text-neutral-400 md:block">{slide.text}</p>
        </div>
      ))}
    </div>
  </Section>
);

export default Credos;
